import { useMutation, useQueryClient } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";
import { medicalExaminationQueryKeys } from "./queryKeys";

export const useDeleteMedicalExaminationCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(MedicalExaminationService.deleteCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries(medicalExaminationQueryKeys.all);
    },
  });
};
